module.exports = __webpack_public_path__ + "img/vertical_6_7_5.e5cdbff4.png";